module.exports = __webpack_public_path__ + "img/banner1-2.10181d39.png";